import React from "react";
import Tooltip from "./Tooltip.jsx";

export default function ContentBlock({children, title = null, tooltip = null}) {
    return (
        <div className={"comp__roundedBox bg-white dark:bg-slate-800 shadow-lg rounded-sm mb-8 p-4"}>

            {tooltip && <Tooltip bg="dark" size="lg" className="inline-flex float-right" position={'bottom'}>
                {tooltip}
            </Tooltip>}

            {title && <div className={'font-semibold text-slate-800 dark:text-slate-100'}>
                {title}
            </div>}

            {(title || tooltip) && <hr className={'my-1'}/>}

            {children}
        </div>
    )
}
